import template from 'lodash.template'

const INTERPOLATE = /\{\{([\s\S]+?)\}\}/g

const compileTemplate = (selector) => {
  const tmpl = document.querySelector(selector)

  return template(tmpl.innerHTML, { interpolate: INTERPOLATE })
}

const messageBuilder = (selector) => (message) => {
  const compiled = compileTemplate(selector)
  const id = Math.random().toString(36).slice(2)

  $('body').append(compiled({ id, message }))
}

export const flashNotice = messageBuilder('#notice-msg-template')
export const flashError = messageBuilder('#error-msg-template')

// Make these funcs available globally so that we can use them on Rails JS views / responses.
window.flashNotice = flashNotice
window.flashError = flashError
